import Api from "@/Services/Api";

export default {
  capturePayment() {
    const data = {
      token: this.getPaypalToken(),
    };

    return Api.post('payment/paypal/capture', data);
  },

  getPaypalToken() {
    let searchParams = new URLSearchParams(window.location.search);

    return searchParams.get('token');
  },

  isPayPalOrder() {
    return this.getPaypalToken() !== null;
  }
};
